import React, { Component } from "react";
import {inject, observer} from 'mobx-react';
import { withRouter } from "react-router-dom";
import ReactQuill from 'react-quill';

import { PageWrapper } from "components/PageWrapper";
import { Question } from "../components/Question";

import HttpClient from 'services/HttpClient';

const SESSION_API = '/api/v1/sessions';
const ANSWER_API = '/api/v1/session_answers';
const QUESTION_API = '/api/v1/mcq_questions';

@withRouter
@inject("mcqSessionStore")
@inject('alertStore')
@observer
export class ActiveSession extends Component {
  constructor() {
    super();

    this.state = {
      isSubmitedQuestion: false,
      questionIndex: 0,
      lastAnswerId: 0,
      isPrevQuestion: false,
    };
  }

  componentDidMount() {
    this.loadSession();
  }

  loadSession = () => {
    const { match, mcqSessionStore: { setSession }, alertStore } = this.props;
    const { sessionId } = match.params;

    new HttpClient().get(`${ SESSION_API }/${ sessionId }`)
   .then(({ body }) => {
      const { session } = body.data || {};
      const isAllAnswered = session.answered_count === session.mcq_question_ids.length;
      setSession(session);
      this.setState({
        questionIndex: session.answered_count ? session.answered_count - 1 : 0,
        isPrevQuestion: false,
        isSubmitedQuestion: isAllAnswered,
      }, () => this.getQuestion());
    })
    .catch(() => {
      alertStore.error('Something went wrong. Please try again.');
    });
  }

  submitAnswer = () => {
    const { mcqSessionStore: { session, answerIndex, setQuestion }, alertStore } = this.props;
    const { questionIndex } = this.state;
    const data = {
      session_id: session.id,
      mcq_question_id: session.mcq_question_ids[questionIndex],
      selected_option_index: answerIndex,
    };
    new HttpClient().post(ANSWER_API, data)
    .then(({ body }) => {
      const optionsParsed = (body.data.question.options || []).map(option => JSON.parse((option || '').replaceAll('=>', ':')));
      const clearedQuestion = _.assign(body.data.question, {
        options: optionsParsed,
      })
      setQuestion(clearedQuestion);

      this.setState({
        isSubmitedQuestion: true,
      });
    })
    .catch(() => {
      alertStore.error('Something went wrong. Please try again.');
    });
  };

  getQuestion = () => {
    const { mcqSessionStore: { session, setQuestion }, alertStore } = this.props;
    const { questionIndex } = this.state;
    const questionId = questionIndex > session.mcq_question_ids.length - 1 ?
      session.mcq_question_ids[session.mcq_question_ids.length - 1] :
      session.mcq_question_ids[questionIndex];

    new HttpClient().get(`${QUESTION_API}/${questionId}`)
    .then(({ body }) => {
      const options_without_correct = body.data.question.options_without_correct.map(option => option);
      const optionsParsed = (body.data.question.options || []).map(option => JSON.parse((option || '').replaceAll('=>', ':')));
      const clearedQuestion = _.assign(body.data.question, {
        options_without_correct,
        optionsParsed,
      })
      setQuestion(clearedQuestion);
    })
    .catch(() => {
      alertStore.error('Something went wrong. Please try again.');
    });
  }

  handleNextQuestion = () => {
    const { mcqSessionStore } = this.props;
    const { isPrevQuestion } = this.state;

    mcqSessionStore.changeAnswerIndex(null);
    if (isPrevQuestion) {
      this.loadSession();
    }
    this.setState((prevState) => ({
      questionIndex: prevState.questionIndex + 1,
      isSubmitedQuestion: false,
      lastAnswerId: 0,
    }), () => this.getQuestion());
  };

  handlePreviousQuestion = () => {
    const { questionIndex, lastAnswerId } = this.state;
    const { mcqSessionStore: { session, setQuestion, changeAnswerIndex }, alertStore } = this.props;
    const lastAnswerParam = lastAnswerId ? `&last_answer_id=${lastAnswerId}` : '';

    new HttpClient().get(`${ANSWER_API}/previous_question?session_id=${session.id}${lastAnswerParam}`)
    .then(({ body }) => {
      const optionsParsed = (body.data.question.options || []).map(option => JSON.parse((option || '').replaceAll('=>', ':')));
      const clearedQuestion = _.assign(body.data.question, {
        options: optionsParsed,
      })
      setQuestion(clearedQuestion);
      changeAnswerIndex(body.data.answer.selected_option_index);

      this.setState({
        isSubmitedQuestion: true,
        questionIndex: questionIndex - 1,
        lastAnswerId: body.data.answer.id,
        isPrevQuestion: true,
      });
    })
    .catch(() => {
      alertStore.error('Something went wrong. Please try again.');
    });
  };

  handleFinish = () => {
    const { history, match, mcqSessionStore: { session }, alertStore } = this.props;
    const id = match.params.id;

    new HttpClient().post(`${SESSION_API}/${session.id}/end_session`)
    .then(() => {
      history.push(`/exam-prep/${id}/mcq`);
    })
    .catch(() => {
      alertStore.error('Something went wrong. Please try again.');
    });
  }

  renderButton = () => {
    const { isSubmitedQuestion } = this.state;
    const { mcqSessionStore: { answerIndex } } = this.props;

    return isSubmitedQuestion ? (
      <button className="btn-new-main" onClick={this.handleNextQuestion}>Next Question</button>
    ) : (
      <button className="btn-new-main" onClick={this.submitAnswer} disabled={!answerIndex && answerIndex !== 0}>Answer</button>
    )
  }

  render() {
    const { mcqSessionStore: { session, question } } = this.props;
    const { isSubmitedQuestion, questionIndex } = this.state;
    const isLastQuestion = (session.mcq_question_ids || []).length - 1 === questionIndex;

    return (
      <PageWrapper>
        <div className="mcq-tab">
          <div className="mcq-card mcq-card-row-between">
            <p>{`${questionIndex + 1}/${(session.mcq_question_ids || []).length}`}</p>
          </div>
          {session.id ? (
            <div className="mcq-card mcq-card-row-between">
              <Question
                id={session.mcq_question_ids[questionIndex]}
                isSubmitedQuestion={isSubmitedQuestion}
              />
            </div>
          ) : null}

          {isSubmitedQuestion && (
            <div className="mcq-card">
              <span className="font-bolder">Key learning points:</span>
              <ReactQuill
                name={ 'key_learnings' }
                value={ question.key_learnings || '' }
                className="quill-toolbar-disabled"
                readOnly={true}
              >
                <div style={{ width: '100%', border: 0 }}></div>
              </ReactQuill>
            </div>
          )}
          {isSubmitedQuestion && (
            <div className="mcq-card">
              <span className="font-bolder">Explanation:</span>
              <ReactQuill
                name={ 'explanation' }
                value={ question.explanation || '' }
                className="quill-toolbar-disabled"
                readOnly={true}
                
              >
                <div style={{ width: '100%', border: 0 }}></div>
              </ReactQuill>
            </div>
          )}
          <div className="mcq-card" style={{gap: '16px'}}>
            {isLastQuestion && isSubmitedQuestion ? (
              <button className="btn-new-main" onClick={this.handleFinish}>Finish</button>
            ) : this.renderButton()}
            <button
              className="btn-new-main"
              disabled={questionIndex === 0}
              onClick={this.handlePreviousQuestion}
            >
              Previous
            </button>
          </div>
        </div>
      </PageWrapper>
    );
  }
};



// WEBPACK FOOTER //
// ./src/modules/mcq/containers/ActiveSession.js